import Navbar from '../../components/layout/Navbar';
import ChemicalsContent from '../../components/sections/ChemicalsContent';
import Footer from '../../components/layout/Footer';

export default function QuimicosPage() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar activeSection="quimicos" />

      <main className="pt-16">
        <ChemicalsContent />
      </main>

      <Footer />
    </div>
  );
}